<div id="introductionPageBlockContainer" [ngStyle]="{'background': this.backgroundColor}">
    <h1>{{ title }}</h1>
</div>